	<button style="width: 90%; height: 90%; margin-left: 5%;" class="mat-elevation-z0" (click)="this.clicked()"
	[ngClass]="{'main-button' : id!=currentSelected, 'main-button-selected' : id==currentSelected}">
		<div class="mat-elevation-z0 fx-layout-row fx-align-center-center">
			<div class="fx-flex-20" [ngClass]="{'icon-container' : id!=currentSelected, 'icon-container-selected' : id==currentSelected}">
					<mat-icon fontSet="material-icons-outlined"
					[ngClass]="{'main-icon' : id!=currentSelected, 'main-icon-selected' : id==currentSelected}">{{this.icon}}</mat-icon>
			</div>
			<div class="text fx-flex-80 fx-align-center-center">
				{{this.text}}
			</div>
		</div>
	</button>
